<template>
  <div>
    <v-text-field
      v-if="showItem"
      :label="item.label"
      v-model="item.value"
      :rules="rulesValidation"
      :maxlength="item.maxlength ? item.maxlength: 1000"
      :disabled="disabled || item.readonly"
      :persistent-hint="!localItem"
      hint="E' possibile creare automaticamente un barcode"
      :error="barcodeError"
      :error-messages="barcodeError ? errorMessage : ''"
      :loading="verificaInCorso"
      @change=onChange>
      <template v-slot:prepend>
        <!-- mdi-credit-card-multiple-outline -->
        <v-icon color="info" @click="barcodeMultipli" title="Gestione barcode multipli">mdi-tag-multiple-outline</v-icon>        
      </template>    
      <template v-slot:append-outer>
        <v-icon color="success" @click="generaBarcode" title="Genera un nuovo barcode">mdi-barcode</v-icon>
      </template>
    </v-text-field>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card :loading="loading">
        <v-card-title>
          <span class="text-h5">Barcode associati al prodotto</span>
        </v-card-title>       
        <v-card-text>
          <v-data-table :headers="headersBarcode" :items="elencoBarcode" dense hide-default-footer disable-sort :items-per-page="-1">
            <template v-slot:[`item.codice`]="{ item }">
              <v-edit-dialog :return-value.sync="item.codice" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveBarcode(item)">
                <div>{{ item.codice || 'Inserire il Codice'}}</div>
                <template v-slot:input>
                  <div class="mt-4 text-h6">Barcode</div>
                  <v-text-field v-model="item.codice" label="Valore" single-line autofocus placeholder="codice"></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:[`item.quantita`]="{ item }">
              <v-edit-dialog :return-value.sync="item.quantita" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveQuantita(item)">
                <div>{{ item.quantita || 1 }}</div>
                <template v-slot:input>
                  <div class="mt-4 text-h6">Quantità</div>
                  <v-text-field v-model="item.quantita" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                </template>
              </v-edit-dialog>
            </template>                
            <template v-slot:[`item.attivo`]="{ item }">
              <v-simple-checkbox v-model="item.attivo" :ripple="false" dense @click="onSaveAttivo(item)"></v-simple-checkbox>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" dark small @click="onNuovoBarcode">
            Nuovo barcode
          </v-btn>           
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog=false">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="onSalvaBarcode">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="420px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione barcode ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>    
  </div>
</template>

<script>
  import prodotti from '@/services/prodottiService.js'
  import { validazioni } from '@/mixins/validazioni.js'

  export default {
    name: 'barcode',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,      
      disabled: { type: Boolean, default: false }
    },
    data: (vm) => ({
      localItem: vm && vm.item ? vm.item.value : '',
      barcodeError: false,
      verificaInCorso: false,
      errorMessage: '',
      originalValue: vm && vm.item && vm.item.value ? JSON.parse(JSON.stringify(vm.item.value)) : '',
      dialog: false,
      loading: false,
      headersBarcode: [
        { text: 'BARCODE', value: 'codice', align: 'start' },
        { text: `QUANTITA'`, value: 'quantita', align: 'end' },
        { text: 'ATTIVO', value: 'attivo', align: 'center' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
      elencoBarcode: [],
      editedItem: null,
      editedIndex: -1,
      dialogDelete: false
    }),
    mounted() {
      this.originalValue = this.item && this.item.value ? JSON.parse(JSON.stringify(this.item.value)) : ''
      this.elencoBarcode = this.appoggio.barcode || []
    },
    watch: {
      showDrawer(value) {
        if (value && this.item && this.item.value) {
          this.originalValue = JSON.parse(JSON.stringify(this.item.value))
        }
      }
    },
    computed: {
      showDrawer() {
        return this.$store.getters.rightDrawer
      },
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      }
    },
    methods: {
      async generaBarcode() {
        var newcode
        if (this.appoggio.pesoVariabile) {
          newcode = await prodotti.generaBarcodeProdottoPV()
        } else {
          newcode = await prodotti.generaBarcodeProdotto()
        }
        this.originalValue = newcode
        this.nuovoBarcode(newcode)
        this.onChange(newcode)
      },
      async barcodeMultipli() {
        this.dialog = true
      },
      async onSalvaBarcode() {
        const primoBC = _.get(this, 'elencoBarcode[0].codice', '')
        console.log(this.elencoBarcode)
        if (this.elencoBarcode.length > 0 && this.item.value !== primoBC) {
          const newcode = primoBC
          this.originalValue = newcode
          // this.elencoBarcode = this.elencoBarcode.filter(x => x.codice !== newcode) // Altrimenti viene duplicato
          this.onChange(newcode)
        }
        this.dialog = false
      },
      async onChange(value) {
        if (value) {
          this.barcodeError = false
          this.verificaInCorso = true
          const result = await prodotti.verificaBarcodeValido(value)
          this.verificaInCorso = false
          if (result.status === 'ok' || (result.status === 'error' && this.originalValue === value)) {
            this.barcodeError = false
            this.item.value = value
            this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value })
          } else {
            this.barcodeError = true
            this. errorMessage = result.error
          }
        }
      },
      async onSaveBarcode(item) {
        // const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
        // await this.aggiornaPrezzo(item, valore)
      },
      async onSaveQuantita(item) {

      },
      async onSaveAttivo(item) {

      },
      onNuovoBarcode() {
        this.nuovoBarcode('')
      },
      nuovoBarcode(newcode) {
        this.elencoBarcode.push({
          codice: newcode,
          quantita: 1,
          attivo: true
        })
      },
      deleteItem (item) {
        this.editedIndex = this.elencoBarcode.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.elencoBarcode.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      }
    }
  }
</script>
